import React, { useCallback } from "react";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import ListItemIcon from "@mui/material/ListItemIcon";

const KMKMenu = ({ anchorEl, setAnchorEl, meuOptions, marginTop, marginLeft, handleCancel }) => {
  const isSettingMenuOpen = Boolean(anchorEl);

  const handleJobsMenuClose = useCallback(
    (e) => {
      e.stopPropagation();
      setAnchorEl(null);
      handleCancel?.();
    },
    [handleCancel, setAnchorEl]
  );

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      keepMounted
      open={isSettingMenuOpen}
      onClose={handleJobsMenuClose}
      slotProps={{
        paper: {
          style: {
            borderRadius: "12px",
          },
        },
      }}
      sx={{
        marginTop: marginTop || "5px",
        marginLeft: marginLeft || undefined,
        "& .MuiMenuItem-root": {
          fontSize: 14,
        },
      }}
    >
      {meuOptions.map(({ title, id, handleClick, icon, color, disabled }) => {
        return (
          <MenuItem
            key={id}
            data-id={id}
            onClick={handleClick}
            sx={{ width: "150px", padding: icon ? "2px 8px" : "6px 16px" }}
            disabled={disabled}
          >
            {icon ? <ListItemIcon>{icon}</ListItemIcon> : <></>}
            <Typography variant="body2" sx={{ width: "100%", ...(icon ? { ml: 1 } : {}) }} color={color}>
              {title}
            </Typography>
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default React.memo(KMKMenu);
